import React, { ReactChild, forwardRef } from "react";

import clsx from "clsx";

import { ArrowDown2Icon } from "@plex/icons";

import styles from "./MenuTextButton.module.scss";

export interface IMenuTextButton {
  className?: string;
  enabled?: boolean;
  onClick?: () => void;
  children: ReactChild | ReactChild[];
}

export const MenuTextButton = forwardRef<HTMLButtonElement, IMenuTextButton>(({ children, className, enabled = true, onClick }, ref) => {
  return (
    <button type="button" onClick={enabled ? onClick : undefined} ref={ref} className={clsx({ [styles.menuButton]: enabled, [styles.menuButtonDisabled]: !enabled }, className)}>
      {children}
      {enabled && (
        <i className={styles.menuButtonIcon}>
          <ArrowDown2Icon />
        </i>
      )}
    </button>
  );
});

MenuTextButton.displayName = "MenuTextButton";
